import React from "react";
import { reveal } from "../styles/animations";
import { components, typography } from "../styles/designSystem";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";

export const CTA = ({ sectionRef, visible, title, subtitle }) => (
  <section
    ref={sectionRef}
    className={`${reveal(visible)} relative mt-24 overflow-hidden rounded-[2.5rem] border border-secondary/10 bg-secondary px-7 py-12 text-center shadow-2xl md:px-12 md:py-16`}
  >
    <div className="pointer-events-none absolute -left-20 -top-24 h-64 w-64 rounded-full bg-primary/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-20 -right-16 h-56 w-56 rotate-45 rounded-3xl bg-accent/15 blur-2xl" />

    {/* Hexagon + orbiting dot */}
    <svg
      className="pointer-events-none absolute left-[8%] top-8 h-16 w-16 text-white/[0.12]"
      viewBox="0 0 100 100"
      fill="none"
    >
      <polygon
        points="50,3 93,25 93,75 50,97 7,75 7,25"
        stroke="currentColor"
        strokeWidth="2.5"
      />
    </svg>
    <div className="pointer-events-none absolute right-[14%] bottom-10">
      <div className="animate-orbit h-3 w-3 rounded-full bg-white/25" />
    </div>

    {/* Animated dashed wave */}
    <svg
      className="pointer-events-none absolute top-0 left-0 w-full h-8 text-white/[0.08]"
      viewBox="0 0 800 32"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M0 16 Q100 0 200 16 T400 16 T600 16 T800 16"
        stroke="currentColor"
        strokeWidth="2"
        strokeDasharray="8 6"
        className="animate-dash"
      />
    </svg>

    {/* Ticket cut-outs */}
    <div className="pointer-events-none absolute -left-4 top-1/2 h-8 w-8 -translate-y-1/2 rounded-full bg-white" />
    <div className="pointer-events-none absolute -right-4 top-1/2 h-8 w-8 -translate-y-1/2 rounded-full bg-white" />

    <div className="relative mx-auto max-w-2xl border-y border-dashed border-white/15 py-3">
      <h3 className={`${typography.heading.h2} text-white`}>{title}</h3>
      <p className={`${typography.body.base} text-white/75 mx-auto mt-5`}>
        {subtitle}
      </p>
      <Link
        to="/contact"
        className={`${components.button.primary} mx-auto mt-8`}
      >
        Get in touch
        <FiArrowUpRight className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </Link>
    </div>
  </section>
);
